module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7jy7jf/tc-custom/9780547525150.jpg?1705693051405",
      "alt": "This image is the cover for the book Great Railway Bazaar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Great Railway Bazaar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The acclaimed author recounts his epic journey across Europe and Asia in this international bestselling classic of travel literature: “Compulsive reading” (Graham Greene).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In 1973, Paul Theroux embarked on a four-month journey by train from the United Kingdom through Europe, the Middle East, and Southeast Asia. In "), _c('i', [_vm._v("The Great Railway Bazaar")]), _vm._v(", he records in vivid detail and penetrating insight the many fascinating incidents, adventures, and encounters of his grand, intercontinental tour."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Asia's fabled trains—the Orient Express, the Khyber Pass Local, the Frontier Mail, the Golden Arrow to Kuala Lumpur, the Mandalay Express, the Trans-Siberian Express—are the stars of a journey that takes Theroux on a loop eastbound from London's Victoria Station to Tokyo Central, then back from Japan on the Trans-Siberian. Brimming with Theroux's signature humor and wry observations, this engrossing chronicle is essential reading for both the ardent adventurer and the armchair traveler.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Theroux\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0